module.exports = {
    en: {
        // language for the root path e.g. for www.deriv.com
        is_default: true,
        path: 'en',
        display_name: 'English',
        short_name: 'EN',
        affiliate_lang: 0,
    },
    pt: {
        path: 'pt',
        display_name: 'Português',
        short_name: 'PT',
        affiliate_lang: 9,
    },
    es: {
        path: 'es',
        display_name: 'Español',
        short_name: 'ES',
        affiliate_lang: 8,
    },
    ru: {
        path: 'ru',
        display_name: 'Русский',
        short_name: 'RU',
        affiliate_lang: 1,
    },
    fr: {
        path: 'fr',
        display_name: 'Français',
        short_name: 'FR',
        affiliate_lang: 2,
    },
    th: {
        path: 'th',
        display_name: 'Thai',
        short_name: 'TH',
        affiliate_lang: 12,
    },
    id: {
        path: 'id',
        display_name: 'Indonesia',
        short_name: 'ID',
        affiliate_lang: 4,
    },
    vi: {
        path: 'vi',
        display_name: 'Tiếng Việt',
        short_name: 'VI',
        affiliate_lang: 6,
    },
    it: {
        path: 'it',
        display_name: 'Italiano',
        short_name: 'IT',
        affiliate_lang: 3,
    },
    zh_cn: {
        path: 'zh-cn',
        display_name: '简体中文',
        short_name: '简体',
        affiliate_lang: 10,
    },
    pl: {
        path: 'pl',
        display_name: 'Polish',
        short_name: 'PL',
        affiliate_lang: 5,
    },
    zh_tw: {
        path: 'zh-tw',
        display_name: '繁體中文',
        short_name: '繁體',
        affiliate_lang: 11,
    },
    ach: {
        path: 'ach',
        display_name: 'Crowdin',
        short_name: 'CR',
        affiliate_lang: 13,
    },
    tr: {
        path: 'tr',
        display_name: 'Türkçe',
        short_name: 'TR',
        affiliate_lang: 14,
    },
    // TODO: uncomment when supported
    // de: {
    //     path: 'de',
    //     display_name: 'Deutsch',
    // },
    // TODO: uncomment when supported
}
